export const KwanMobileFive = () => {
    return (
        <div className="flex flex-col items-center pt-[22px] px-[20px]">
            <div className="text-[rgba(51,51,51,1)] text-center font-['Alibaba_PuHuiTi_3.0'] text-[18px] font-bold ">
                我们的优势
            </div>
            <img src="/imgs/saas/process.png" className="mt-[18px] mx-auto" />
            <div className="flex justify-center mt-[13px]">
                <div className="text-[12px] text-[#FFFFFF] font-medium text-center w-[87px] h-[24px] flex flex-row justify-center items-center  py-[4px] rounded-[3.84px] [background:linear-gradient(135deg,rgba(94.81,150.87,255,1)_0%,rgba(1,130,255,1)_100%)]">
                    立即咨询使用
                </div>
            </div>
        </div>
    );
}